import type { RouteObject } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import LoginPage from "@/pages/auth/Login";
import RegisterPage from "@/pages/auth/Register";
import ForgotPasswordPage from "@/pages/auth/ForgotPassword";
import SettingsPage from "@/pages/settings/page";
import GeneratorPage from "@/pages/generator/page";
import MyQRPage from "@/pages/myqr/page";
import StatisticsPage from "@/pages/statistics/page";
import PricingPage from "@/pages/pricing/page";
import ContactPage from "@/pages/contact/page";
import DownloadPage from "@/pages/download/page";
import RedirectPage from "@/pages/redirect/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/r",
    element: <RedirectPage />,
  },
  {
    path: "/login",
    element: <LoginPage />,
  },
  {
    path: "/register",
    element: <RegisterPage />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
  },
  {
    path: "/generator",
    element: (
      <ProtectedRoute>
        <GeneratorPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/my-qr",
    element: (
      <ProtectedRoute>
        <MyQRPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/settings",
    element: (
      <ProtectedRoute>
        <SettingsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: "/download",
    element: <DownloadPage />,
  },
  {
    path: "/statistics",
    element: <StatisticsPage />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
